import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { SettingsMutateForm } from "../features/SettingsMutateForm";

export const PlanningSettingsMutatePage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const title = t("planning.settings");

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{t("planning.breadcrumb")}</BreadCrumbItem>
            <BreadCrumbItem to="/planning/settings">
              {t("planning.settings.breadcrumb")}
            </BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <SettingsMutateForm />
      </LayoutContent>
    </Layout>
  );
};
